export type OngoingVendorReviewPerfStatus = 'PENDING' | 'DUE SOON' | 'COMPLETED' | 'OVER DUE';
export type OngoingVendorReviewPeriodicStatus = 'PENDING' | 'DUE SOON' | 'OVER DUE' | 'COMPLETED';

export interface OngoingVendorReviewRow {
  id: string;
  vendorName: string;
  department: string;
  outsourcingType: string;
  performanceFrequency: string;
  performanceStatus: OngoingVendorReviewPerfStatus;
  performanceNext: string;
  periodicFrequency: string;
  periodicStatus: OngoingVendorReviewPeriodicStatus;
  periodicNext: string;
}

export type OngoingVendorReviewViewMode = 'list' | 'monthly' | 'periodic';

export type OngoingVendorReviewPeriodicAnnexureVisual = 'completed' | 'current' | 'pending' | 'notApplicable';

export type OngoingVendorReviewPeriodicAnnexureRow = {
  id: string;
  codeLabel: string;
  title: string;
  description: string;
  visual: OngoingVendorReviewPeriodicAnnexureVisual;
};

/** Designer row ids for Annexure 11 (17 cards; skips duplicate KYC row `n11_new_3`). */
export const MONTHLY_ANNEXURE_11_ROW_IDS: readonly string[] = [
  'n11_new_1',
  'n11_new_2',
  'n11_new_4',
  'n11_new_5',
  'n11_new_6',
  'n11_new_7',
  'n11_new_8',
  'n11_new_9',
  'n11_new_10',
  'n11_new_11',
  'n11_new_12',
  'n11_new_13',
  'n11_new_14',
  'n11_new_15',
  'n11_new_16',
  'n11_new_17',
  'n11_new_18',
];

export const MONTHLY_PERFORMANCE_INDICATORS: readonly string[] = [
  'Service Agreement Documents Available',
  'Service Agreement End Date',
  'KYC Document Review Applicable (Y/N)',
  'If Yes, Next KYC Documents Review Date',
  'Updated Contact Details Available',
  'Number Of Service Requests Raised',
  'Number Of Service Requests Pending',
  'Service Issues Identified & Corrected',
  'Sample Checking Undertaken By Respective Owner Department (Yes / No / NA)',
  'Outcome Of Sample Testing',
  'Critical Problem Areas Recognized',
  'SLA Breaches (If Any)',
  'KPI Outcome',
  'Adverse Media Screening',
  'Date Of Annual Review Done And Outcome',
  'Whether The Vendor Is Supporting IBS',
  'Overall Performance Outcome (Based On Monthly Review As Per Outsourcing And Third Party Arrangement Policy)',
];

export const PERIODIC_ANNEXURE_ROWS: OngoingVendorReviewPeriodicAnnexureRow[] = [
  {
    id: 'a6',
    codeLabel: 'Code 6',
    title: 'Annexure 6 – KYC Due Diligence Form',
    description: 'Verify vendor identity, ownership, compliance documents, and regulatory background details.',
    visual: 'completed',
  },
  {
    id: 'a7',
    codeLabel: 'Code 7',
    title: 'Annexure 7 – Materiality Assessment Form',
    description: 'Evaluate vendor criticality, operational impact, business dependency, and associated organizational risks.',
    visual: 'current',
  },
  {
    id: 'a8',
    codeLabel: 'Code 8',
    title: 'Annexure 8 – Risk Assessment Form',
    description: 'Identify security, compliance, operational, and financial risks related to vendor engagement.',
    visual: 'pending',
  },
  {
    id: 'a10',
    codeLabel: 'Code 10',
    title: 'Annexure 10 – Service Provider Periodic Assessment',
    description: 'Review vendor performance, SLA compliance, service quality, and ongoing operational effectiveness.',
    visual: 'pending',
  },
  {
    id: 'a12',
    codeLabel: 'Code 12',
    title: 'Annexure 12 – Vendor Visit format',
    description: 'Document onsite vendor observations, infrastructure review, controls, and operational assessment findings.',
    visual: 'pending',
  },
  {
    id: 'a13',
    codeLabel: 'Code 13',
    title: 'Annexure 13 – Business Continuity Plan and Disaster Recovery Assessment',
    description:
      'Assess vendor recovery preparedness, continuity strategies, backup processes, and incident response capabilities.',
    visual: 'pending',
  },
];
